import React from 'react';

import type {SubClass} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {subClassDescription} from './class-seo-text';

type Props = {
	subClass: SubClass;
	classId: string;
};

export const SubClassSeo: React.FC<Props> = ({subClass, classId}) => {
	const path = buildUrl('subClass', {id: classId, subClassId: subClass.id});

	return (
		<EntitySeo
			entity={subClass}
			section="classes"
			kind={`подкласс класса ${subClass.classTitle},`}
			description={subClassDescription(subClass)}
			path={path}
			og={{kind: 'subclass'}}
			keywords={[subClass.classTitle]}
			crumbs={[
				{name: subClass.classTitle, path: buildUrl('class', {id: classId})},
				{name: 'Подклассы', path: buildUrl('subClasses', {id: classId})},
				{name: subClass.title, path},
			]}
		/>
	);
};
